import { IModel } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';
import { ParquetDataset } from 'shell-models-lib';
import { ParquetFormatWriteSettings } from './format-write-settings/parquet-format-write-settings';
import { FormatTypeCopySink } from './format-type.copysink';

@Metamodel.model({
    name: 'ParquetSink',
    display: [],
    referable: true,
    tags: { datasetModel: Metamodel.modelFor(ParquetDataset) }
})
export class ParquetSink extends FormatTypeCopySink {
    public static readonly MODEL: IModel;

    @Metamodel.attribute({
        display: stringResources.ModelName_FormatReadSettings,
        type: ParquetFormatWriteSettings.MODEL
    })
    public formatSettings: ParquetFormatWriteSettings;
}
